export default (theme) => ({
  container: {
    display: 'flex',
    gap: theme.spacing(3),
    flexWrap: 'wrap',
  },
  card: {
    minWidth: 250,
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    alignItems: 'center',

    '&:last-child': {
      paddingBottom: theme.spacing(2),
    },
  },
  cardContentActiveDot: {
    position: 'absolute',
    top: theme.spacing(0.5),
    right: theme.spacing(0.5),
    display: 'flex',
  },
});
